export default "__VITE_ASSET__DLHCnKcB__"